import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styleClasses from "../../containers/try2/try2.module.scss";
import { useAppSelector } from "../../redux/store/store";
import Heading from "../../components/kidsCombo/Heading";
import ItemSelection from "../../components/kidsCombo/ItemSelection/ItemSelection";
import LocationModal from "../../components/General/Modals/LocationModal";
import { IKidsCombo } from "../../models/kidsCombo";
import Spinner from "../../components/Spinner/Spinner";
import KidsComboSelectionData from "./data";
import { itemBuckets } from "../../priceCalculation/buckets";
import * as CONSTANT from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  addKidsComboItem,
  editKidsComboItemSelection,
  resetContext,
  updateModifiers,
  updatePriceForAllItem,
  updatePriceForItem,
  updateTry2ComboSelectedModifiers,
} from "../../redux/slices/itemCustomizationSlice";
import ComplementaryItems from "../try2/subComponents/ComplementaryItems";
import { calculatePriceForItem } from "../../priceCalculation/calculatePrice";
import {
  ICoreModifiers,
  IRequiredModifiersGroupsModifiers,
} from "../../models/item.model";
import { useAuthState } from "../../context/UserAuthentication";
import AddToOrder from "../try2/subComponents/AddToOrder";
import { getVisitorId } from "../../helpers/helperMethods";
import useAddToOrder from "../../hooks/useAddToOrder";
import { createPayloadToSync, processEditItemModifiers } from "../../helpers/customizedItem/customizedItem.helper";
import { finalOrder } from "../../helpers/combo";
import useGetCartItem from "../../react-query-hooks/Cart/useGetCartItem";
import { IGetItemFromCartPayload } from "../../models/order.model";
import { modifiersAgainstAnItem } from "../../priceCalculation/helper";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import { useQueryClient } from "react-query";
import AddedModal from "../order/AddedModal/AddedModal";
import { OrderNameForm } from "../../components/OrderAnItem/OrderNameForm/OrderNameForm";
import { updateAllItemAddedStateForKidsCombo } from "../../redux/slices/itemSlice";
import {useStoreLocation} from "../../context/StoreLocation";
import useGetRewards from "../../react-query-hooks/useGetRewards";
import {cartItem} from "../../models/cart.model";

const KidsCombo: React.FC<IKidsCombo> = ({
  location_id,
  item_id,
  favorites,
  favoriteButtonHandler,
  kidsComboPropData,
  showCustomization,
  dbId,
  itemFromApi,
  isFetching,
  refetch,
  name,
  routeStates
}) => {
  const dispatchItems = useDispatch();
  const queryClient = useQueryClient()
  const { addToOrder, loading } = useAddToOrder();
  const order = useAppSelector((state: any) => state.itemCustomization);
  const kidsComboStates = useAppSelector((state: any) => state.Items.kidsComboItem);

  const isOrderTypeSelected = useAppSelector(
    (state) => state.cart.isOrderTypeSelected
  );
  const history = useHistory()
  const [showLocationModal, setShowLocationModal] = useState<boolean>(!isOrderTypeSelected);
  const recentlyDeletedId = useSelector((state: any) => state.cart.recentlyDeletedId);

  const { authInfo } = useAuthState();

  const [forceRender, setForceRender] = useState<boolean>(false)
  const [successModalShow, setSuccessModalShow] = useState<boolean>(false);
  const [quantity, setQuantity] = useState<number>(1);
  const [madeForName, setMadeForName] = useState<string>('');
  const [customizedItem, setCustomizedItem] = useState<cartItem>(null);

  const scrollToOrderRef = useRef<HTMLDivElement>(null);


  const showCompletmentary = () => {
    let show: boolean = true;
    if (order?.name) {
      for (let i = 0; i < order?.modifiers.length - 1; i++) {
        if (!order?.modifiers[i]?.is_selected) {
          show = false;
        }
      }
      return show
    } else {
      return false;
    }
  }

  const scrollAddToOrderToCenter = (value:number) => {
    scrollToOrderRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    const elementRect = scrollToOrderRef?.current?.getBoundingClientRect();
    if(elementRect){
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / value);
      window.scrollTo(0, middle);
    }
  }


  useEffect(() => {
    if(kidsComboStates.isAllThreeItemAdded) {
      scrollAddToOrderToCenter(4);
      dispatchItems(updateAllItemAddedStateForKidsCombo({allItemSelectionState:false}))
    }
  },[scrollToOrderRef, kidsComboStates.isAllThreeItemAdded])

  const payload: IGetItemFromCartPayload = {
    id: dbId,
    location_id: location_id,
  }
  if (authInfo.userId) payload.customer_id = authInfo.userId
  else payload.visitor_id = getVisitorId()

  const { data: editCartItem, refetch: fetchItem, isFetching: editItemFetching, isError } = useGetCartItem(payload);

  const itemData = itemFromApi?.items[0]
  useEffect(() => {
    if (!showCustomization || !dbId) return;
    if (recentlyDeletedId === Number(dbId) || isError) {
      toast.error("This Item does not exist!")
      resetURL()
      resetKidsCombo()
    }
  }, [recentlyDeletedId, isError])

  useEffect(() => {
    if(editCartItem && dbId){
      setQuantity(editCartItem?.quantity);
      setMadeForName(editCartItem?.recipient_name)
    }
  },[editCartItem])

  const resetURL = () => {
    history.replace(`${CONSTANT.ROUTE_MENU}/${CONSTANT.KIDS_COMBO_CAPITALIZE}`, {
      showCustomization: false
    })
    queryClient.resetQueries("get-cart-item")
  }
  useEffect(() => {
    resetKidsCombo()
    return () => {
      itemBuckets.resetBuckets();
      dispatchItems(resetContext());
    };
  }, []);

  useEffect(() => {
    if (showCustomization && dbId) {
      resetKidsCombo()
      fetchItem()
    }
  }, [showCustomization, dbId])

  const shouldRender = () => {
    return order.id != item_id && !isFetching && itemData && !editItemFetching
  }

  useEffect(() => {
    if (shouldRender()) {
      dispatchItems(addKidsComboItem(itemData));
      itemData && handleInitialSync()
    }
  }, [isFetching, editCartItem]);

  const handleInitialSync = async () => {
    if (showCustomization && (!editCartItem)) return;
    if (itemData) await handleComplimentaryModifiers(itemData)
    if (showCustomization && editCartItem) {
      await processEditItemModifiers({ complementary_modifiers: editCartItem.complementary_modifiers }, itemFromApi?.items[0], CONSTANT.KIDS_COMBO_ITEM, 4)
      for (let i = 0; i < CONSTANT.KIDS_COMBO_SELECTED_SECTION; i++) {
        const cartItem = editCartItem.modifiers[i]
        if (!cartItem.is_item) return;
        let section = (i + 1).toString()
        await processEditItemModifiers(cartItem, null, CONSTANT.KIDS_COMBO_ITEM, i + 1);
        dispatchItems(editKidsComboItemSelection({ id: editCartItem.id, sectionSelected: section, item: cartItem, base: editCartItem.group_base_price }));
      }
    }
    updateModifierStates()
  };

  const updateModifierStates = () => {
    const modifierPrices = []
    const itemBucket = itemBuckets.getBuckets();

    itemBucket?.forEach(currentItemBucket => {
      const bucketTypes = Object.keys(currentItemBucket?.bucket);

      bucketTypes.forEach(type => {
        const activeBucket = currentItemBucket?.bucket[type]
        const itemId = currentItemBucket?.item === 4 ? CONSTANT.COMPLEMENTARY_ITEM : currentItemBucket?.item
        modifierPrices.push({ activeBucket, itemId })
      });
    })
    const firstItem = modifiersAgainstAnItem({itemType:CONSTANT.SINGLE_ITEM, itemId: CONSTANT.SINGLE_ITEM_SELECTED_SECTION})
    const secondItem = modifiersAgainstAnItem({itemType:CONSTANT.TRY_TO_COMBO_ITEM, itemId: CONSTANT.TRY_TO_COMBO_SELECTED_SECTION})
    const thirdItem = modifiersAgainstAnItem({itemType:CONSTANT.KIDS_COMBO_ITEM, itemId: CONSTANT.KIDS_COMBO_SELECTED_SECTION})
    const complimentaryModifiers = modifiersAgainstAnItem({itemType:CONSTANT.COMPLEMENTARY_ITEM, itemId: CONSTANT.COMPLEMENTARY_SELECTED_SECTION_FOR_KIDS_COMBO_ITEM})
    const modifiers = []

    modifiers.push({ itemModifiers: firstItem, itemId: 1 })
    modifiers.push({ itemModifiers: secondItem, itemId: 2 })
    modifiers.push({ itemModifiers: thirdItem, itemId: 3 })
    modifiers.push({ itemModifiers: complimentaryModifiers, itemId: CONSTANT.COMPLEMENTARY_ITEM })

    dispatchItems(updateModifiers(modifiers))
    dispatchItems(updatePriceForAllItem(modifierPrices))
  }

  const handleComplimentaryModifiers = async (item: any) => {
    const complimentaryModifiers = item.complementary_items ?? []
    complimentaryModifiers.forEach(modifier => {
      modifier.modifiers_groups_modifiers?.forEach(selectedItem => {
        if (!selectedItem.is_selected) return;
        let payload = createPayloadToSync({ ...selectedItem, modifier_type: CONSTANT.COMPLIMENTARY_MODIFIER }, item)
        calculatePriceForItem({currentModifier:payload, item_id: CONSTANT.COMPLEMENTARY_SELECTED_SECTION_FOR_KIDS_COMBO_ITEM});
      });
    });
    return true;
  }





  // Wrapper function for add ingredients
  const handleComplementaryIngredientSelection: (
    data: any,
    id?: 1|2|3|4
  ) => void = (data, id=CONSTANT.COMPLEMENTARY_SELECTED_SECTION_FOR_KIDS_COMBO_ITEM) => {
    const { itemId, activeBucket, itemModifiers } = calculatePriceForItem(
      {
        currentModifier: data,
        item_id: id
      }
    );
    dispatchItems(
      updateTry2ComboSelectedModifiers({
        itemModifiers,
        itemId: itemId,
      })
    );
    if (activeBucket !== undefined) {
      dispatchItems(updatePriceForItem({ itemId, activeBucket }));
    }
    setForceRender(!forceRender)
  };
  const unrepeatedIngredients: (
    | ICoreModifiers
    | IRequiredModifiersGroupsModifiers
  )[] = itemData
      ? [
        ...itemData?.core_modifiers,
        ...itemData?.items_required_modifier_groups
          .map((group) => group?.required_modifiers_groups_modifiers)
          .flat(),
      ]
      : [];

  const resetKidsCombo = () => {
    itemBuckets.createComboBucket(
      {
        keys: [CONSTANT.CORE_MODIFIERS, CONSTANT.REQUIRED_MODIFIERS, CONSTANT.COMPLIMENTARY_MODIFIER, CONSTANT.ADD_ONS],
        items: 3
      }
    );
    dispatchItems(resetContext());
  };

  const { locationInfo } = useStoreLocation();
  const { data: allRewards = [] } = useGetRewards(
      authInfo.userId,
      locationInfo.selectedStore?.id,
      1,
      1,
      1,
      authInfo?.type
  );
  const handleAddToOrder = async (order) => {
    const finalOrderObject:any = finalOrder({ order, category_id: null, noOfItems: 3, comboType: CONSTANT.COMBO_TYPE_IS_KIDS_COMBO, items: itemFromApi, state: routeStates, allRewards: allRewards });
    finalOrderObject.recipient_name = madeForName;
    const response = await addToOrder(finalOrderObject, true, quantity);
    if (response) {
      resetURL()
      resetKidsCombo();
      refetch()
      window.scrollTo(0, 0);
      setCustomizedItem(finalOrderObject)
      !dbId && setSuccessModalShow(true);
      setQuantity(1)
      setMadeForName('')
    };
  }

  const isLoading = () => {
    return isFetching || editItemFetching || itemBuckets.getBuckets().length <= 3
  }
  if (isLoading())
    return (
      <div className={styleClasses.try2_loader_wrapper}>
        <Spinner AlignSpinner={"align-spiner-center"} />
      </div>

    )


  return (
    <Container
      className={`${styleClasses.kids_combo_wrapper} pb-5 px-lg-4 px-0 px-md-0`}
    >
      <LocationModal showModal={showLocationModal} setShowModal={setShowLocationModal} itemPath={ {
          pathname: `${CONSTANT.ROUTE_MENU}/${name}`,
          search: '',
          state: {}
        }}/>
      <Heading
        name={itemData ? itemData?.name : kidsComboPropData.name}
        description={
          itemData ? itemData?.description : kidsComboPropData.description
        }
        price={itemData ? order?.display_price : kidsComboPropData?.price}
        originalPrice={
          itemData ? order?.original_price : kidsComboPropData?.price
        }
        image={itemData ? itemData?.image : kidsComboPropData?.image}
        authInfo={authInfo}
        favourite={favorites}
        favoriteButtonHandler={favoriteButtonHandler}
        item={itemData ? itemData : kidsComboPropData}
      />
      <hr className="my-2 d-none d-md-block" />
      <ItemSelection
        order={order}
        itemData={itemData}
        selectionData={KidsComboSelectionData}
        location_id={location_id}
      />
      {showCompletmentary() && (
        <div className={styleClasses.comple_wrap} ref={scrollToOrderRef}>
          <ComplementaryItems
            itemFromApi={itemData}
            unrepeatedIngredients={unrepeatedIngredients}
            handleIngredientSelection={handleComplementaryIngredientSelection}
            itemNo={4}
            FullSize={"col-lg-10"}
            items_count={"col-lg-3 col-4"}
          />
          <div className={styleClasses.order_name_form_wrap}>
          <OrderNameForm try2ComboPadding={'pe-3 ps-0'} setQuantity={(quantity:number) => setQuantity(quantity)}
                         isRedeemedItem={routeStates?.isItemRedeemed || routeStates?.isReward}
                         quantity={quantity} madeFor={madeForName} setMadeForName={(name:string) => setMadeForName(name)}/>
          </div>

        </div>
      )}
      <Row>
        <Col>
          {isOrderTypeSelected ? (
            <AddToOrder
              order={order}
              loading={loading}
              addToOrder={() => handleAddToOrder(order)}
              showCustomization={showCustomization}
            />
          ) : (
            <div className="text-center">
              <button
                type="button"
                className="btn btn-large mb-sm-4 mb-3 d-block mx-auto"
                onClick={() => {
                  setShowLocationModal(true);
                }}
              >
                Select A Location
              </button>
            </div>
          )}
        </Col>
      </Row>
      {successModalShow && <AddedModal item={customizedItem} showModal={successModalShow} closeModal={() => setSuccessModalShow(false)} name={itemFromApi?.items[0]?.name} image={`${CONSTANT.REACT_APP_CLOUD_FRONT}${itemFromApi?.items[0]?.image}`} isCombo={true} itemFromApi={itemFromApi}/>}
    </Container>
  );
};

export default KidsCombo;
